// Copyright (c) 2017+,COMUNICARE SOLUTIONS SA
// All rights reserved.
//
// Redistribution and use in source and binary forms, with or without modification,
// are NOT permitted.

import { FHIR_ActivityHelper } from "../helpers/fhirActivityHelper";
import { Activity } from "./careplan";
import { ACTIVITY_LOCATION, ACTIVITY_CATEGORY, Period } from "./sharedInterfaces";

/**
 * This property "transforms" a ScheduledActivity into a ScheduledItem
 */
export class ScheduledActivity implements Period {
  public start: string; //  ISO 8601 Datetime
  public end: string; //  ISO 8601 Datetime
  public location: ACTIVITY_LOCATION;
  public category: ACTIVITY_CATEGORY;
  public description: string;

  /**
   * constructor
   */
  constructor(activity: Activity, date: string) {
    this.start = date;
    this.location = FHIR_ActivityHelper.getLocation(activity);
    this.category = FHIR_ActivityHelper.getCategory(activity);
    this.description = FHIR_ActivityHelper.getDescription(activity);
  }

  /**
   *
   */
  /*get start(): Date {
        return this.date;
    }*/
}
